import React from 'react'

const Plus = (props: any) => {
  return (
    <svg {...props} width="100%" height="100%" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_3_43)">
        <path
          d="M3.20325 7H12.8282"
          stroke="currentColor"
          strokeWidth="0.875"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.01575 2.1875V11.8125"
          stroke="currentColor"
          strokeWidth="0.875"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3_43">
          <rect width="14" height="14" fill="white" transform="translate(1.01575)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default Plus
